import type { AssetsLiabilities, FinancialAccount } from "@/types/types";
import { isFinancialAccount } from "./bal-helper";
import { formatNumber } from "devextreme/localization";

type Props = {
  account: FinancialAccount | AssetsLiabilities;
  isLifeInsuranceSection?: boolean;
  isNonAssetBal?: boolean;
};

export default function Account({ account, isLifeInsuranceSection, isNonAssetBal = false }: Props) {
  const isStockAccount = account?.type === "Stock";
  const isAOAccount = account?.type === "AO Investment Account";
  const isLifeInsuranceAccount = account?.type === "Life Insurance";

  const showBalance = !isLifeInsuranceSection && isFinancialAccount(account);
  const isNonAssetBalLifeInsurance = isLifeInsuranceAccount && isNonAssetBal;

  const classes = `rounded-[0.25rem] border 
  ${!account?.tacticalSolution && account?.validationNeeded ? "!border-danger" : "border-neutral-500"} 
  ${account?.tacticalSolution && !account?.validationNeeded ? "!border-accent-400" : "border-neutral-500"} 
  ${account?.tacticalSolution && account?.validationNeeded ? "!border-accent-400 outline outline-[1px] outline-offset-[-6px] !outline-error" : "border-neutral-500"} 
  ${isAOAccount ? "font-medium" : ""} px-4 py-2 print:text-sm`;

  if (
    isFinancialAccount(account) &&
    (account?.totalBalance || account?.deathBenefitValue) &&
    isNonAssetBalLifeInsurance
  ) {
    return (
      <div className={`grid grid-cols-[auto_9rem] gap-x-2 gap-y-1`}>
        {account?.totalBalance ? (
          <>
            <span className={`${classes}`}>{account?.balanceSheetName ?? ""}</span>
            <span className={classes}>{formatNumber(account?.totalBalance, "$ #,##0")}</span>
          </>
        ) : null}
        {account?.deathBenefitValue ? (
          <>
            <span className={`${classes}`}>{account?.nonAssetBALLifeInsuranceName ?? ""}</span>
            <span className={classes}>{formatNumber(account?.deathBenefitValue, "$ #,##0")}</span>
          </>
        ) : null}
      </div>
    );
  }

  return (
    <div className={`grid grid-cols-[auto_9rem] gap-x-2`}>
      {(showBalance && isLifeInsuranceAccount && account?.totalBalance > 0) ||
      (!isLifeInsuranceSection && isStockAccount) ||
      (isLifeInsuranceSection && isLifeInsuranceAccount) ||
      (!isLifeInsuranceSection && !isLifeInsuranceAccount && !isStockAccount) ? (
        <>
          <span className={classes}>
            {isLifeInsuranceAccount && isFinancialAccount(account) && isLifeInsuranceSection
              ? account?.lifeInsuranceBalanceSheetName
              : account?.balanceSheetName}
          </span>
          <span className={classes}>
            {isLifeInsuranceSection && isLifeInsuranceAccount && isFinancialAccount(account)
              ? formatNumber(account?.deathBenefitValue, "$ #,##0")
              : isStockAccount && isFinancialAccount(account)
                ? formatNumber(account?.totalBalance ?? 0, "$ #,##0")
                : isFinancialAccount(account)
                  ? formatNumber(account?.totalBalance, "$ #,##0")
                  : formatNumber(account?.amount, "$ #,##0")}
          </span>
        </>
      ) : null}
    </div>
  );
}
